export const display = (value: any, defaultEmptyValue = '—') => {
  if (value === null || value === undefined || value === '' || value === 0 || Number.isNaN(value)) {
    return defaultEmptyValue;
  } else {
    return String(value);
  }
};

